import { createContext, useContext, useState, useEffect } from "react";
import { adminLogin, adminMe, adminLogout } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("oaa_admin_token");
    if (!token) {
      setChecking(false);
      return;
    }
    adminMe()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("oaa_admin_token");
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const res = await adminLogin(email, password);
    localStorage.setItem("oaa_admin_token", res.token);
    setUser(res);
    return res;
  };

  const logout = async () => {
    try { await adminLogout(); } catch (e) {}
    localStorage.removeItem("oaa_admin_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
